import { useEffect, useMemo, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { z } from 'zod';

import {
  DatePickerInput,
  NumberInput,
  TextInputReactRouterSearch,
} from 'components/shared';
import type { DatePickerInputValue } from 'components/shared/Inputs/DatePickerInput/DatePickerInput';

export const FormsTableFiltersRow = () => {
  const [date, setDate] = useState<DatePickerInputValue>([null, null]);
  const [, setSearchParams] = useSearchParams();
  const { t } = useTranslation(['common', 'templates']);

  useEffect(() => {
    const [newFrom] = date;
    const newTo = date.length === 1 ? newFrom : date[1];
    setSearchParams(prev => {
      if (newFrom) prev.set('from', newFrom);
      else prev.delete('from');
      if (newTo) prev.set('to', newTo);
      else prev.delete('to');
      return prev;
    });
  }, [date]);

  return (
    <tr>
      <td />
      <td>
        <TextInputReactRouterSearch
          placeholder={t('templates:name')}
          icon={null}
        />
      </td>
      <td>
        <NumberInput
          placeholder={t('templates:id')}
          withErrorWrapperAlwaysEnabled={false}
          value={undefined}
          onChange={value => {
            if (value === undefined) {
              setSearchParams(prev => {
                prev.delete('id');
                return prev;
              });
            } else {
              setSearchParams(prev => {
                prev.set('id', value.toString());
                return prev;
              });
            }
          }}
        />
      </td>
      <td>
        <DatePickerInput
          withErrorWrapperAlwaysEnabled={false}
          date={date}
          setDate={setDate}
        />
      </td>
      {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
      <td />
    </tr>
  );
};
